import { LabelEnum } from 'app/shared/enums';
import { getValueFromFormattedPrice } from './getValueFromFormattedPrice';

export const addToFormattedPrice = (
  formattedPrice: string,
  addition: number
): string => {
  if (!addition) {
    return formattedPrice;
  }

  const value = getValueFromFormattedPrice(formattedPrice) + addition;
  const [integerPart, decimalPart] = value.toFixed(2).split('.');
  const groupedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return `${groupedIntegerPart},${decimalPart} ${LabelEnum.ZL}`;
};
